module.exports = "img {\n    padding-right: 2px;\n}\n\nh3 {\n    width: 40px;\n}\n\n.pro-header p {\n    padding: 0px 150px 5px 150px;\n    font-size: 14px;\n}\n\n.program-container .pro-header {\n    height: 110px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin.component.css
// module id = ./src/app/admin/admin.component.css
// module chunks = main